import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "previewContainer", "removeCheckbox", "spinner", "error"]
  static values = {
    url: String,
    field: String
  }

  connect() {
    this.inputTarget.addEventListener("change", this.upload.bind(this))
  }

  browse() {
    this.inputTarget.click()
  }

  async upload(event) {
    const file = event.target.files[0]
    if (!file) return

    // Show spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }

    // Clear previous errors
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
      this.errorTarget.textContent = ""
    }

    const formData = new FormData()
    formData.append("field", this.fieldValue)
    formData.append("file", file)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok) {
        // Update preview
        if (this.hasPreviewTarget && data.url) {
          this.previewTarget.src = data.url
          this.previewTarget.classList.remove("hidden")
        }

        // Hide placeholder, show preview container
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add("hidden")
        }
        if (this.hasPreviewContainerTarget) {
          this.previewContainerTarget.classList.remove("hidden")
        }

        // Uncheck remove checkbox if it exists
        if (this.hasRemoveCheckboxTarget) {
          this.removeCheckboxTarget.checked = false
          this.removeCheckboxTarget.closest("label")?.classList.remove("hidden")
        }
      } else {
        this.showError(data.error || "Upload failed")
      }
    } catch (error) {
      console.error("Upload error:", error)
      this.showError("Upload failed. Please try again.")
    } finally {
      // Hide spinner
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.add("hidden")
      }

      // Clear the input so the same file can be selected again
      this.inputTarget.value = ""
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    }
  }

  remove() {
    // Hide preview and preview container
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }
    if (this.hasPreviewContainerTarget) {
      this.previewContainerTarget.classList.add("hidden")
    }

    // Show placeholder
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }

    // Check the remove checkbox
    if (this.hasRemoveCheckboxTarget) {
      this.removeCheckboxTarget.checked = true
    }
  }
}
